import { render } from "./affected-lists.vue?vue&type=template&id=6a1acd05&scoped=true"
import script from "./affected-lists.vue?vue&type=script&lang=js"
export * from "./affected-lists.vue?vue&type=script&lang=js"

import "./affected-lists.vue?vue&type=style&index=0&id=6a1acd05&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1acd05"]])

export default __exports__